/**
 * Checks whether a web browser is the Samsung Internet Browser.
 *
 * @returns {boolean}
 */
export function isSamsungBrowser() {
  return navigator.userAgent.includes('SamsungBrowser');
}
